(function($) {

   function initTimeLine() {

     // Get the page and container metrics
     pageWidth = $(document).outerWidth();
     leftOffset = $('#footerInner').offset();
     rightOffset = leftOffset;

     // Pad the left and right of the slider
     $('.slider').css({'margin-left':leftOffset.left+10});
     $('.slider').css({'margin-right':leftOffset.left});

     // Reset the scroll position
     $('#tline').scrollLeft(0);

   }

   var trig_count = 0;

   $(document).ready(function(){

      //-------------------------------------------
      //Activate ReadMore.JS
      //-------------------------------------------
      $('.read-more').readmore({
         speed: 275,
         moreLink: '<a href="#" class="btn btn-default">READ MORE</a>',
         lessLink: '<a href="#" class="btn btn-default">READ LESS</a>',
         embedCSS: false
      });


      //-------------------------------------------
      //Handle Burger button
      //-------------------------------------------
      $('#mainButton').click(function(){
         //$(this).toggleClass('opened');
         $('#responsive-menu').slideDown();
      });
      $('#closeButton').click(function(){
         //$(this).toggleClass('opened');
         $('#responsive-menu').slideUp();
      });


      //-------------------------------------------
      //Initialize Home News Slider
      //-------------------------------------------
      $('#hero-banner').owlCarousel({
         items:1,
         margin:0,
         loop:true,
         autoplay:true,
         autoplayTimeout : 5500,
         autoplaySpeed:700,
         nav:false,
         dots:false
      });


      //-------------------------------------------
      //Burger button responsive
      //-------------------------------------------
      $('.header .top-menu .burger-btn').click(function(){
         $(this).toggleClass('opened');
         $('.responsive-nav').slideToggle();
      });


      // Any element .trig-link, create link to data-url
      $('.aaatrig-link').click(function(){
        var linkUrl = $(this).attr('data-url');
        document.location.href = linkUrl;
      });      

      // Need to be able to scroll without clicking, get any clicks with a down up of less than 200
      $( ".trig-link" ).mousedown(function() {
        trigCount = Date.now();
      });


      $( ".trig-link" ).mouseup(function() {
        trigCount = Date.now() - trigCount;

        if(trigCount < 200) {
          var linkUrl = $(this).attr('data-url');
          document.location.href = linkUrl;
        }

        console.log(trigCount);
      });

      if ($('#service_type').length > 0) {
         hash = $('#service_type').val();

         $('html, body').animate({
           scrollTop: $('[id*="'+hash+'"]').offset().top
         }, 800, function(){
           window.location.hash = hash;
         });

         $('[id*="'+hash+'"]').collapse('show');
      }


      //-------------------------------------------
      //MatchHeight these elements
      //-------------------------------------------
      var match_selectors = [
         '.feature-box',
         '.contact-box',
         '.testimonial-box',
         '.testimonial-box .content',
         '.testimonial-box .row'
      ];

      for (var i=0; i < match_selectors.length; i++) {
         $(match_selectors[i]).matchHeight();
      }

      $('#tline-nav .trig:nth-of-type(1)').addClass('active');

      $('#tline-outer').on('click','.trigButton', function() {

        var currentPos = 1; found = false;
        var sliderOffset = parseInt(jQuery('#tline').scrollLeft());
      
        $( ".slc.c1" ).each(function( index ) {
          elementOffset = $(this).offset().left;

          elementOffset2 = $(this).siblings('.c2').offset().left;
          console.log(elementOffset + ' ' + elementOffset2);
          if(parseInt(elementOffset) > 0) {            
            found = true;
          }
          
          if(!found) {
            currentPos++;
          }
        });

        if ($(this).hasClass('prev')) {

          newOffset = $('.slc.s' + (currentPos-1) + '.c1').offset().left;
          newValue = newOffset+sliderOffset-10;
          //$('#tline').scrollLeft(newOffset+sliderOffset-10);
          $('#tline').animate( { 'scrollLeft':newValue }, 700,'swing');
          currentPos--;

        } else {

          newOffset = $('.slc.s' + (currentPos+1) + '.c1').offset().left;
          newValue = newOffset+sliderOffset-10;
          //$('#tline').scrollLeft(newOffset+sliderOffset-10);
          $('#tline').animate( { 'scrollLeft':newValue }, 700,'swing');
          currentPos++;

        }

        // Enable left and right buttons as approrpriate
        if(currentPos === 1) {
          $('.trigButton.prev').addClass('off');
        } else {
          $('.trigButton.prev').removeClass('off');
        }

        if(currentPos === 5) {
          $('.trigButton.next').addClass('off');
        } else {
          $('.trigButton.next').removeClass('off');
        }

        //console.log(currentPos);


         /*currentpos = $('#tline-nav .trig.active').index();

         if ((currentpos+1) >= 5 && $(this).hasClass('next')) {
            $('#trig-next').addClass('off');
         } else if ((currentpos-1) <= 1 && $(this).hasClass('prev')) {
            $('#trig-prev').addClass('off');
         } else {
            $('.trigButton').removeClass('off');
         }

         if ($(this).hasClass('prev')) {
            //prev button
            if ((currentpos-1) >= 1) {
               $('#tline-nav .trig').removeClass('active');
               $('#tline-nav .trig:eq('+(currentpos-2)+')').addClass('active');
               var _targetClass = $('#tline-nav .trig:eq('+(currentpos-2)+')').attr('data-class');
               var _targetLeft = jQuery('#tline .' + _targetClass).offset();
               var _sliderOffset = jQuery('#tline').scrollLeft();
               $('#tline').scrollLeft(_targetLeft.left+_sliderOffset-10);
            }
         } else {
            //next button
            if ((currentpos+1) <= 5) {
               $('#tline-nav .trig').removeClass('active');
               $('#tline-nav .trig:eq('+(currentpos)+')').addClass('active');
               var _targetClass2 = $('#tline-nav .trig:eq('+(currentpos)+')').attr('data-class');
               alert(_targetClass2);
               var _targetLeft2 = jQuery('#tline .' + _targetClass2).offset();
               var _sliderOffset2 = jQuery('#tline').scrollLeft();
               $('#tline').scrollLeft(_targetLeft2.left+_sliderOffset2-10);
            }
         }*/

      });


      /*
      $( "#tline-nav" ).on( "click", ".trig", function() {
         $('.trig').removeClass('active');
         $(this).addClass('active');
        // When a trigger is clicked, find the position of the appropriate class, offset by the screller scroll value and
        // move the slider to that element
        var targetClass = jQuery(this).attr('data-class');

        var targetLeft = jQuery('#tline .' + targetClass).offset();
        var sliderOffset = jQuery('#tline').scrollLeft();

        $('#tline').scrollLeft(targetLeft.left+sliderOffset-10);

        $('.trigButton').removeClass('off');

          if ($(this).is(':first-of-type')) {
             $('.trigButton.prev').addClass('off');
          } else if ($(this).is(':last-of-type')) {
             $('.trigButton.next').addClass('off');
          }

      });*/


   });


   $(window).load(function(){
      $('.initial-hidden').css('opacity',1);
      initTimeLine();


      $( ".trig-link" ).each(function( index ) {
        var current_link = $(this).attr('data-url');

        if(current_link !== '') {
          $(this).css({'cursor':'pointer'});
        }
        
      });      

      

    $("#tline").scroll(function(){

      var currentPos = 1; found = false;
      var sliderOffset = parseInt(jQuery('#tline').scrollLeft());
      var sliderWidth = $('#tline .slider').outerWidth();
      var documentWidth = $(document).outerWidth();

      //console.log(sliderOffset + ' ' + sliderWidth + ' ' + documentWidth);
    
      $( ".slc.c1" ).each(function( index ) {
        elementOffset = $(this).offset().left;

        if(parseInt(elementOffset) > 0) {            
          found = true;
        }
        
        if(!found) {
          currentPos++;
        }
      });

      // Enable left and right buttons as approrpriate
      if(currentPos === 1) {
        $('.trigButton.prev').addClass('off');
      } else {
        $('.trigButton.prev').removeClass('off');
      }

      if(currentPos === 5 || sliderOffset+documentWidth > sliderWidth) {
        $('.trigButton.next').addClass('off');
      } else {
        $('.trigButton.next').removeClass('off');
      }        

    });

   });

   $(window).resize(function() {
      initTimeLine();
   });




})(jQuery); // Fully reference jQuery after this point.
